module.exports = __webpack_public_path__ + "static/img/5.ac2f87f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/5.png
// module id = A8Kx
// module chunks = 0